module.exports = __webpack_public_path__ + "static/img/yvlongboche.77bdd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/yvlongboche.png
// module id = IXB9
// module chunks = 0